/**
 * Minimal React entrypoint for the welcoming web app.
 */

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

const APP_NAME = "Eliza Welcome Web App";

function App() {
  return (
    <main
      style={{
        fontFamily: "system-ui, sans-serif",
        padding: "2rem",
        textAlign: "center",
        maxWidth: "800px",
        margin: "0 auto",
        color: "#333",
        lineHeight: "1.6",
      }}
    >
      <h1 style={{ fontSize: "2.5rem", color: "#4A90E2" }}>Welcome to {APP_NAME}</h1>
      <p style={{ fontSize: "1.2rem" }}>
        Explore the possibilities of the Eliza ecosystem. This is a production-ready web application
        built as part of the Eliza OS apps collection.
      </p>
      <div
        style={{
          marginTop: "2rem",
          padding: "1rem",
          border: "1px solid #ddd",
          borderRadius: "8px",
          backgroundColor: "#f9f9f9",
        }}
      >
        <p>
          Status: <span style={{ color: "green", fontWeight: "bold" }}>Online</span>
        </p>
        <p>Platform: Eliza OS</p>
      </div>
    </main>
  );
}

const container = document.getElementById("root");
if (!container) {
  throw new Error("Missing #root element");
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
